module.exports = __webpack_public_path__ + "img/avatar.7bcd6b7b.png";